import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppSelector } from '@/store';
import { authSelector } from '@/store/reducers/auth';
import { ROUTES } from '@/admin/config/routes';
import { UserRole } from '@/school-management/types/roles';
import ClassOverview from '@/components/ClassOverview/ClassOverview';

/**
 * Admin route: /schools/:schoolId/class/:classId
 * Teacher route: /dashboard/my-classes/:classId
 * UI + styles live in @/components/ClassOverview (shared with teacher dashboard).
 */
export default function ViewClassPage() {
  const navigate = useNavigate();
  const { schoolId: routeSchoolId, classId } = useParams<{
    schoolId: string;
    classId: string;
  }>();
  const { user, userRole } = useAppSelector(authSelector);
  const organizationId = user?.metadata?.organizationDetails?.organizationId || '';
  const apiSchoolId = organizationId || routeSchoolId || '';

  const canEditClass =
    userRole === UserRole.Admin ||
    userRole === UserRole.SuperAdmin ||
    userRole === UserRole.RegionManager;

  if (!classId) {
    return null;
  }

  return (
    <ClassOverview
      classId={classId}
      organizationId={apiSchoolId}
      canEditClass={canEditClass}
      onBack={() => {
        const sid = routeSchoolId || apiSchoolId;
        navigate(`${ROUTES.SCHOOL_DETAILS(sid)}?tab=classes`);
      }}
      onEditClass={
        canEditClass ? () => navigate(ROUTES.EDIT_CLASS(apiSchoolId, classId)) : undefined
      }
    />
  );
}
